import React, { useState } from 'react';
import '../../styles/denuncia.css';

const CanalDenuncia: React.FC = () => {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    denunciante: '',
    tipo: '',
    relato: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Simular envio para back-end
    console.log('Formulário enviado:', formData);
    alert('Denúncia enviada com sucesso!');

    // Limpa o formulário
    setFormData({
      nome: '',
      telefone: '',
      email: '',
      denunciante: '',
      tipo: '',
      relato: ''
    });
  };

  return (
    <div className="container-denuncia">
      <h2 className="titulo">Canal de Denúncias</h2>
      <form className="formulario" onSubmit={handleSubmit}>
        <input
          type="text"
          name="nome"
          placeholder="Nome (opcional)"
          value={formData.nome}
          onChange={handleChange}
        />
        <input
          type="tel"
          name="telefone"
          placeholder="Telefone (opcional)"
          value={formData.telefone}
          onChange={handleChange}
        />
        <input
          type="email"
          name="email"
          placeholder="E-mail (opcional)"
          value={formData.email}
          onChange={handleChange}
        />

        <select name="denunciante" value={formData.denunciante} onChange={handleChange} required>
          <option value="">Denunciante</option>
          <option value="anônimo">Anônimo</option>
          <option value="identificado">Identificado</option>
        </select>

        <select name="tipo" value={formData.tipo} onChange={handleChange} required>
          <option value="">Tipo de Denúncia</option>
          <option value="assédio">Assédio</option>
          <option value="discriminação">Discriminação</option>
          <option value="conduta_inadequada">Conduta Inadequada</option>
          <option value="outros">Outros</option>
        </select>

        <textarea
          name="relato"
          placeholder="Escreva seu relato"
          value={formData.relato}
          onChange={handleChange}
          required
        />

        <button type="submit" className="botao-enviar">Enviar</button>
      </form>

      <div className="lgpd">
        <strong>Compromisso com a ética e o respeito.</strong>
        <p>
          Este canal é exclusivo para o registro de denúncias relacionadas a condutas inadequadas, irregularidades ou qualquer situação que viole os princípios éticos e legais da clínica.
          As informações aqui registradas serão tratadas com sigilo absoluto, em conformidade com a Lei Geral de Proteção de Dados (LGPD).
          Sua manifestação é essencial para garantir um ambiente seguro, transparente e íntegro para todos.
        </p>
      </div>
    </div>
  );
};

export default CanalDenuncia;
